module.exports = __webpack_public_path__ + "img/calculator.c7f58ad7.svg";